import type { Address } from "@/screen/Identities/Interfaces/IdentityFormInterfaces";
import { isKnownRoadType } from "@/screen/Identities/IdentityForm/identityAddressValidation";

const REQUIRED_ADDRESS_FIELDS: (keyof Address)[] =
[
    "roadType",
    "streetName",
    "streetNumber",
    "zipCode",
    "city",
    "state",
    "country",
];

export function highlightAddressSubfield(highlightPending: boolean, sectionComplete: boolean, field: keyof Address, address: Address | null): boolean
{
    if(!highlightPending || sectionComplete)
    {
        return false;
    }
    if(!REQUIRED_ADDRESS_FIELDS.includes(field))
    {
        return false;
    }
    // Un código heredado fuera del catálogo se ve vacío en el selector: se resalta como pendiente.
    if(field === "roadType")
    {
        return !isKnownRoadType(address?.roadType);
    }
    const v = address?.[field];
    if(v === undefined || v === null)
    {
        return true;
    }
    return String(v).trim() === "";
}